import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, CTA_GOLD, BADGE_DARK, GLOBS } from "./theme";
import { Background } from "./Background";

export const LinkedInBanner: React.FC<{
  mainText: string;
  subText: string;
  cta: string;
}> = ({ mainText, subText, cta }) => {
  return (
    <AbsoluteFill
      style={{
        background: `linear-gradient(135deg, ${COLORS.dark} 0%, ${COLORS.darkAlt} 100%)`,
        fontFamily: FONTS.sans,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "0 60px",
      }}
    >
      <Background theme="dark" />

      <div
        style={{
          position: "absolute",
          right: -60,
          top: -100,
          width: 350,
          height: 350,
          borderRadius: "50%",
          background: GLOBS.goldSmall,
          filter: "blur(60px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: -80,
          bottom: -100,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: GLOBS.darkGlow,
          filter: "blur(80px)",
        }}
      />

      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          background: COLORS.gold,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 36,
          fontWeight: 700,
          color: COLORS.dark,
          fontFamily: FONTS.serif,
          marginRight: 32,
          flexShrink: 0,
          paddingBottom: 4,
          boxShadow: `0 4px 30px ${COLORS.gold}50`,
        }}
      >
        E
      </div>

      <div style={{ flex: 1, zIndex: 2 }}>
        <div style={{ marginBottom: 8 }}>
          <span style={BADGE_DARK}>ANALISTA CORPORAL</span>
        </div>

        <div
          style={{
            fontFamily: FONTS.serif,
            fontSize: 42,
            fontWeight: 400,
            color: COLORS.white,
            lineHeight: 1.2,
            letterSpacing: "-0.02em",
            marginBottom: 4,
            textShadow: "0 2px 8px rgba(0,0,0,0.3)",
          }}
        >
          {mainText}
        </div>
        <div
          style={{
            fontSize: 18,
            color: COLORS.textMuted,
            fontWeight: 300,
          }}
        >
          {subText}
        </div>
      </div>

      <div
        style={{
          ...CTA_GOLD,
          padding: "12px 32px",
          fontSize: 14,
          whiteSpace: "nowrap",
          flexShrink: 0,
          zIndex: 2,
        }}
      >
        {cta}
      </div>
    </AbsoluteFill>
  );
};
